import React from 'react';
import './MilestoneMoments.css';

function MilestoneMoments({ milestones }) {
  if (!milestones || milestones.length === 0) {
    return null;
  }

  const getTypeIcon = (type) => {
    switch (type) {
      case 'breakthrough':
        return '💡';
      case 'achievement':
        return '🏆';
      case 'gratitude':
        return '🙏';
      case 'learning':
        return '📚';
      case 'connection':
        return '💝';
      default:
        return '⭐';
    }
  };

  const getImpactColor = (impact) => {
    switch (impact) {
      case 'high':
        return '#10B981';
      case 'medium':
        return '#3B82F6';
      case 'low':
        return '#6B7280';
      default:
        return '#6B7280';
    }
  };

  return (
    <div className="milestone-moments">
      <h3 className="milestone-moments__title">Milestone Moments</h3>
      <p className="milestone-moments__subtitle">
        Significant moments from your journey
      </p>

      <div className="milestone-moments__timeline">
        {milestones.map((milestone, index) => (
          <div key={index} className="milestone-moments__item">
            <div className="milestone-moments__connector">
              <div className="milestone-moments__dot" />
              {index < milestones.length - 1 && (
                <div className="milestone-moments__line" />
              )}
            </div>

            <div className="milestone-moments__card">
              <div className="milestone-moments__card-header">
                <div className="milestone-moments__type-icon">
                  {getTypeIcon(milestone.type)}
                </div>
                <div className="milestone-moments__date">
                  {new Date(milestone.date).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </div>
              </div>

              <h4 className="milestone-moments__title-text">{milestone.title}</h4>
              <p className="milestone-moments__description">{milestone.description}</p>

              <div className="milestone-moments__metadata">
                <span 
                  className="milestone-moments__mood"
                  style={{
                    color: getImpactColor(milestone.impact)
                  }}
                >
                  {milestone.mood}
                </span>
                <span 
                  className="milestone-moments__impact"
                  style={{
                    backgroundColor: `${getImpactColor(milestone.impact)}20`,
                    color: getImpactColor(milestone.impact)
                  }}
                >
                  {milestone.impact} impact
                </span>
              </div>

              {milestone.entryId && (
                <button className="milestone-moments__view-entry">
                  View Entry →
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MilestoneMoments;
